import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=55c5aa31&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=55c5aa31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5aa31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c5aa31')) {
      api.createRecord('55c5aa31', component.options)
    } else {
      api.reload('55c5aa31', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=55c5aa31&scoped=true&", function () {
      api.rerender('55c5aa31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/PrivacyPolicy.vue"
export default component.exports